/*
	Definition:
	This plugin handles the new storyteller slide navigation. It's based on the DUI.smartSelectBox.

	Example for HTML SELECT:
		<select class="box1">
			<option value="1" data-selected="true">slide 1</option>
			<option value="2">slide 2</option>
			<option value="3" data-checked="true">slide 3</option>
		</select>

		$('select.box1')
			.DUIslideNavigator({
				'filter':true,
				'height':340,
				'width':330
			});
	
	Parameters:
		name: type [default value] - description

		filter: boolean [false] - defines if a filter box should be visible.
		height: int [144] - defines the height
		maxHeight: int [null] - defines the maxHeight of the expanded panel
		width: int [160] - defines the width. Set to 'auto' for dynamic, i.e. no css width is set
		dropdownclass: string ['DUIslideNavigatorDropDown'] - CSS Class for option list
		filterclass: string ['DUIslideNavigatorFilter'] - CSS Class for filter textbox
		numbering: boolean [false] - defines if numbers should be displayed before the text in the list
		editable: boolean [false] - defines if the text rows are editable (fires "edited" event)
		sortable: boolean [false] - defines if the rows are sortable (fires "sorted" event)
		editableIcon: string [] - defines which icon to use to indicate editing
		tooltip: string [] Text to display as tooltip when hovering the selectbox. Rendered as html 'title' attribute.
		editTooltip: string ['Edit'] - Text to display as tooltip on the edit buttons in the list.
		editOriginalValue: string [] Text that should be removed when editing, if textbox only contain that text.
		filterTooltip: string [] Text that is displayed as tooltip when hovering the filter box.


	Predefined states:
		"selected": Use the data-selected="true" attribute.
		"selectDisabled": Use the data-selectDisabled="true" attribute. (disables the select )

	Events:
		"selected" - Is fired when a row is selected/unselected.
		"edited" - Is fired when a row text is edited. Carries two parameters [evt, @value, text()]

	Methods:
		"select" - $('select.box1').DUIslideNavigator("select", Parameter1); - Selects all items in the list that is in index array Parameter1
		"selected" - $('select.box1').DUIslideNavigator("selected"); - returns a list of selected items.
		"update" - $('select.box1').DUIslideNavigator("update"); - redraws the selectbox with new items (currently full rebind!)
		"destroy" - $('select.box1').DUIslideNavigator("destroy"); - removes the selectbox and restores the original element.
		"remove" - $('select.box1').DUIslideNavigator("remove",index); - removes the option @ index in the selectbox.
		"move" - $('select.box1').DUIslideNavigator("move",index,newIndex); - moves the option @ index to newIndex in the selectbox.
		"add" - $('select.box1').DUIslideNavigator("add",index,value,text,[true/false]); - adds a new option to the selectbox. 
																						Last boolean parameter can be provided to indicate that new option 
																						is to be inserted BEFORE option with provided index.


	Event + get selected items example:
	$('select.box1').live('selected', function(){
		var x = $(this).DUIslideNavigator('selected');
		alert('Selected: '+x);
	})

*/

(function($){

	var slideNavigator_methods = {
		init : function( options ) { 
			// default options
			var settings = $.extend( {
				'filter' : false,
				'height' : 144,
				'width' : 160,
				'dropdownclass' : 'DUIslideNavigatorDropDown',
				'filterclass' : 'DUIslideNavigatorFilter',
				'numbering' : true,
				'editable' : true,
				'sortable' : true,
				'editableIcon' : '',
				'tooltip': '',
				'editTooltip': '',
				'filterTooltip' : '',
				'editOriginalValue' : ''
			}, options);
			//save settings
			slideNavigator_methods.settings = settings;

			//Handle each SELECT element
			$(this).each(function(){
				function uniqeid(){
					var newDate = new Date;
					return newDate.getTime();
				}

				function insertFilter(HTMLCLASS){
					var filterWidth = (settings.width != 'auto') ? 'width:'+parseInt(settings.width-4,10)+'px;' : '';
					sbHTML.push('<div class="'+HTMLCLASS+'_FilterBox"><input type="text" title="'+settings.filterTooltip+'" autocomplete="off" autocapitalize="off" autocorrect="off" style="'+filterWidth+'" class="'+settings.filterclass+'"/></div>');
				}

				var oThis = $(this);
				var sbHTML = [];
				var sbSelectedText = [];
				var HTMLID = 'DUIslideNavigator_'+uniqeid()+'_'+Math.floor(Math.random()*100);
				var DUIOBJECT = ''; //the component's main node

				var widthSingleMode = (settings.width != 'auto') ? 'width:'+parseInt(settings.width-4,10)+'px;' : '';
				sbHTML.push('<div class="DUIslideNavigator" id="'+HTMLID+'" title="'+ settings.tooltip +'">');
				sbHTML.push('<div style="'+widthSingleMode+'" class="DUIslideNavigator_SingleButton">(No Selection)</div>');
				
				//selectbox + filter container
				sbHTML.push('<div class="DUIslideNavigator_SelectBoxContainer">');

				var widthCSS = (settings.width != 'auto') ? 'width:'+settings.width+'px;' : '';
				var heightCSS = 'height:'+settings.height+'px;';

				if (settings.maxHeight )
					heightCSS = 'min-height:'+ settings.height +'px;max-height:'+ settings.maxHeight +'px;¤*height:'+ settings.maxHeight +'px;';

				if (settings.numbering)
					settings.dropdownclass += ' DUIslideNavigatorDropDown_Numbering'

				sbHTML.push('<div style="'+ heightCSS + widthCSS +'overflow-x:hidden;overflow-y:auto;" class="DUIslideNavigator_SelectBox '+settings.dropdownclass+'">');

				oThis.children().each(function(ind){
					var item = $(this);
					var iSelected = (item.attr('data-selected') == 'true');
					var iSelectDisabled = (item.attr('data-selectDisabled') == 'true');

					var items = slideNavigator_methods.createItem({
						index: ind,
						value: item.attr('value'),
						text: HTMLHelpers.htmlEncode(item.text()),
						selected: iSelected,
						selectable: !iSelectDisabled
					});
					sbHTML = sbHTML.concat(items.html);
					sbSelectedText = sbSelectedText.concat(items.selectedTexts);
				});

				sbHTML.push('</div>');

				if( settings.filter ){
					insertFilter('DUIslideNavigator');
				}

				sbHTML.push('</div></div>');


				$(sbHTML.join('')).insertAfter(oThis);
				DUIOBJECT = $('#'+HTMLID);

				var selectbox = $('.DUIslideNavigator_SelectBox',DUIOBJECT);

				//set text selections
				$('.DUIslideNavigator_SingleButton', DUIOBJECT).text(sbSelectedText.join(', '));

				//FILTER HANDLING
				if( settings.filter ){
					$('.DUIslideNavigator_FilterBox',DUIOBJECT).children().keyup(function(){						
						var keyword = $(this).val();
						//set "active" color
						$(this)[0].style.borderColor = (keyword.length > 0) ? '#29abe2' : '#d2d2d2';

						selectbox.children().hide();
						//Check for matches
						//Keyword variations: keyWoRd (original), KEYWORD, keyword, Keyword
						var multiple = keyword.split(' ');
						var multipleLen = multiple.length;
						var query = new Array();
						var i = 0;

						//Handle multiple keywords, using OR          
						for( i;multipleLen>i;i++ ){
							if( multiple[i].length < 1 ) continue; //check for empty entry

							query.push(':contains("'+multiple[i]+'")');
							query.push(':contains("'+multiple[i].toUpperCase()+'")');
							query.push(':contains("'+multiple[i].toLowerCase()+'")');
							query.push(':contains("'+multiple[i].substr(0, 1).toUpperCase() + multiple[i].substr(1).toLowerCase()+'")'); 
						}

						if(query.length > 0) {
							selectbox.children().filter(function(index) {
								var q = query.join(', ');
								var retVal = ($(this).filter(q).length > 0);
								if (!retVal) {
									let text = this.innerText.toLowerCase();
									retVal = text.includes(keyword.toLowerCase())
								}
								if(!retVal && settings.numbering) {
									retVal = ($.inArray($(this).children(':text').val(), multiple) > -1);
								}
								return retVal;
							}).show();
						} else {
							selectbox.children().show();
						}
					})
					.mousedown(function(evt) {
						evt.stopPropagation();
					})
					.mouseup(function(evt) {
						evt.stopPropagation();
					})
					.click(function(evt) {
						evt.stopPropagation();
					});
				}


				$('.DUIslideNavigator_SingleButton',DUIOBJECT)
					.click(function(evt){
						evt.stopPropagation();
						var el = $('.DUIslideNavigator_SelectBoxContainer',DUIOBJECT);
						el.toggle();
					});

				$('.DUIslideNavigator_SelectBox',DUIOBJECT).click(function(evt) {
					evt.stopPropagation();
				});

				$('.DUIslideNavigator_SelectBox',DUIOBJECT).children().each(function(index){
					var _this = $(this)[0];
					slideNavigator_methods.addEventHandler(oThis, _this, index);
				});

				oThis.addClass('DUIslideNavigator').hide();

				if ( settings.sortable )
					selectbox.sortable({
						tolerance: 'pointer',
						cancel: 'button',
						helper: 'clone',
						delay: 100,
						cursorAt: { top: 10 },
						update: function (event, ui) {
							oThis.trigger('sorted', [event, ui]);
						}
					});

			}) //end handle multiple SELECTs
		},
		createItem : function(opt) {
			var sbHTML = [];
			var sbSelectedText = [];

			var options = {
				index: 0,
				value: slideNavigator_methods.settings.numbering ? 0 : '',
				text: slideNavigator_methods.settings.editOriginalValue,
				selected: false,
				selectable: true
			};

			$.extend(options, opt);

			var selClass = (options.selected) ? 'selected' : '';
				selClass += (options.selectable == false) ? 'disabled' : '';
			var selAttr = (options.selectable == false) ? ' data-selectDisabled="true"' : '';

			if( options.selected )
				sbSelectedText.push(options.text);

			sbHTML.push('<div data-value="'+options.value+'" class="'+selClass+'" '+selAttr+'>');

				if (slideNavigator_methods.settings.sortable)
					sbHTML.push('<div class="sort-handle"><i class="DUI-icon DUI-icon-drag"></i></div>');

				if (slideNavigator_methods.settings.numbering)
					sbHTML.push('<input type="text" class="DUIslideNavigator_NumberingBox" autocomplete="off" onfocus="this.blur()" value="' + options.value + '"/>');

				if( slideNavigator_methods.settings.editable == true )
					sbHTML.push('<button type="button" class="DUIslideNavigator_TextEdit linkButton" title="'+ slideNavigator_methods.settings.editTooltip +'"><i class="DUI-icon DUI-icon-edit"></i></button>');
							
				if(options.text.length == 0)
					sbHTML.push('&nbsp;');

				sbHTML.push(options.text);
			sbHTML.push('</div>');
			return { html: sbHTML, selectedTexts: sbSelectedText };
		},
		addEventHandler: function(oThis, _this, index) {
			//oThis => slidenav oThis
			//IE disable text selection
			_this.onselectstart = function(){ event.returnValue = false };

			$(_this).bind('click', function(evt){
				if( (evt.target.nodeName == 'INPUT' && !$(evt.target).hasClass('DUIsmartSelectBox_NumberingBox')) || evt.target.nodeName == 'BUTTON' || evt.target.nodeName == 'I' )
					return;

				var retVal = [];
				var selText;
				
				//Deselect all others
				$(_this).siblings().filter(function() {
					return $(this).attr('data-selectDisabled') !== 'true';
				}).each(function(ind){
					$(this).removeClass('selected');
				});

				$(_this).addClass('selected');

				retVal.push($.trim($(_this).text()));
				retVal.push($.trim($(_this).find('input.DUIslideNavigator_NumberingBox').val() || $(_this).attr('data-value')));

				if(evt.currentTarget.nodeName == 'DIV') 
					$(evt.currentTarget).parents('DIV.DUIslideNavigator').prev().trigger('selected');


				if(slideNavigator_methods.settings.numbering)
					selText = (retVal[0].length > 0) ? (retVal[1]) + ' - ' + retVal[0] : retVal[1];
				else
					selText = retVal[0];

				$(evt.currentTarget).parent().parent().prev('.DUIslideNavigator_SingleButton').text(selText);
				$(evt.currentTarget).parent().parent().prev('.DUIslideNavigator_SingleButton').click();
			});

			if( slideNavigator_methods.settings.editable == true ){
				/* Handle text editing */
				$('.DUIslideNavigator_TextEdit',_this)
					.click(function(evt){
						evt.stopPropagation();
                        $(this).css('display', 'none');
                        
						var inputWidth = parseInt($(this).parent().parent().width(),10) -44;
						var inputDefaultText = ($(this).parent().text() == slideNavigator_methods.settings.editOriginalValue) ? slideNavigator_methods.settings.editOriginalValue : $(this).parent().text();
						inputDefaultText = HTMLHelpers.htmlEncode((inputDefaultText.trim().length > 0) ? inputDefaultText : '');
						var originalText = $(this).parent().text();
						$(this).parent().append('<input class="textEdit" value="'+inputDefaultText+'" title="" style="width:'+inputWidth+'px;"/>');
						var cnodes = $(this).parent()[0].childNodes;
						for( var i=0; i<cnodes.length;i++){
							if( cnodes[i].nodeType == 3 ){
								cnodes[i].nodeValue = '';
								$(this).siblings('DIV:last').css('display','inline');
							}
						}

						$(this).parent().children('.textEdit')
							.focus()
							.click(function(evt){
								evt.stopPropagation();
							})
							.keydown(function (evt) {
								var code = (evt.keyCode ? evt.keyCode : evt.which);
								if(code == 13) {
									evt.preventDefault();
									evt.stopImmediatePropagation();
									$(this).blur();
								}
								if(code == 27) {
									evt.preventDefault();
									evt.stopImmediatePropagation();
									$(this).val(originalText).blur();
								}
							})
							.keyup(function () {
								var limit = 600;
								if ($(this).val().length > limit) {
									$(this).val($(this).val().substring(0, limit));
									Storyboard.LayoutControls.showMessage("Slide name can not be more than " + limit + " characters long");
									return false;
								}
							})
							.blur(function(){
								var newVal = ($(this).val().trim() == '') ? slideNavigator_methods.settings.editOriginalValue : $(this).val();
								for( var i=0; i<cnodes.length;i++){
									if( cnodes[i].nodeType == 3 ){
										cnodes[i].textContent = newVal.length === 0 ? "\u00A0" : newVal;
										$(this).siblings('DIV:last').css('display','block');
									}
								}
								if(originalText != newVal.trim()){
									//fire event
									var retValue = [];
									retValue.push($(this).parent().attr('data-value'));
									retValue.push(newVal);
									retValue.push(slideNavigator_methods.settings.editOriginalValue);
									oThis.trigger('edited', retValue);
								}

								var slideIndex = parseInt($(this).parent().attr('data-value'), 10);
								var layoutSlide = Storyboard.LayoutDesigner.getSlideByIndex(slideIndex);
								layoutSlide.slideName = newVal;

								if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
									Storyboard.SlidesPanel.renderSlides();
								}

								$(this).parent().find('.DUIslideNavigator_TextEdit').css('display', '');
								$(this).remove();
							});
					});
			}
		},
		select : function(selections){
			var oThis = $(this);
			var DUIOBJECT = oThis.next();
			var selectbox = $('.DUIslideNavigator_SelectBox',DUIOBJECT);
			var selectedTexts = '';
			selectbox.children('div.selected').removeClass('selected');
			if( oThis.hasClass('DUIslideNavigator') ){
				selectbox.children('DIV').each(function(index, elem) {
					var itmValue = $(this).attr('data-value');
					if($.inArray(parseInt(itmValue), selections) > -1){
						$(this).addClass('selected');
						if(slideNavigator_methods.settings.numbering) {
							selectedTexts += ',' + (index+1);
							for(var i=0;i<elem.childNodes.length;i++) {
								if(elem.childNodes[i].nodeType == 3 && elem.childNodes[i].nodeValue.trim().length > 0)
									selectedTexts += ' - '+ elem.childNodes[i].nodeValue;
							}
						} else {
							selectedTexts += ',' + $(this).text();
						}
					}
				});
				$('#slideFirst, #slideBack').toggleClass('disabled', selectbox.children('DIV').first().is('.selected'));
				$('#slideLast, #slideNext').toggleClass('disabled', selectbox.children('DIV').last().is('.selected'));
				selectedTexts = selectedTexts.substr(1);
				if(selectedTexts.lastIndexOf(',') == selectedTexts.length-1)
					selectedTexts = selectedTexts.substr(0,selectedTexts.length - 1);
				if(DUIOBJECT.children(':first').hasClass('DUIslideNavigator_SingleButton'))
					$('.DUIslideNavigator_SingleButton',DUIOBJECT).text(selectedTexts);
			}
		},
		selected : function(){
			var oThis = $(this);
			var DUIOBJECT = oThis.next();
			var selectbox = $('.DUIslideNavigator_SelectBox',DUIOBJECT);
			var retVal = [];
			if( oThis.hasClass('DUIslideNavigator') ){
				selectbox.children('div.selected').each(function(index){
					retVal.push($(this).attr('data-value'));
				});
				return retVal;
			}
		},
		update : function() { 
			/* Does not take previously checked or selected into consideration */
			var oThis = $(this);
			if( oThis.hasClass('DUIslideNavigator') ){
				oThis.next().remove(); //smart container
				oThis.removeClass('DUIslideNavigator');
				oThis.DUIslideNavigator(slideNavigator_methods.settings);
			}
		},
		destroy : function(){
			var oThis = $(this);
			if( oThis.hasClass('DUIslideNavigator') ){
				oThis.next().remove(); //smart container
				oThis.removeClass('DUIslideNavigator');
				oThis.show();
			}
		},
		updateText: function (index, text) {
			var oThis = $(this);
			var DUIOBJECT = oThis.next();
			var selectbox = $('.DUIslideNavigator_SelectBox', DUIOBJECT);
			var item = selectbox.children('div[data-value]:eq(' + (index - 1) + ')')[0];

			var cnodes = item.childNodes;
			for (var i = 0; i < cnodes.length; i++) {
				if (cnodes[i].nodeType == 3) {
					cnodes[i].textContent = text.length === 0 ? "\u00A0" : text;
					//$(this).siblings('DIV:last').css('display', 'block');
				}
			}

			var retValue = [];
			retValue.push($(item).attr('data-value'));
			retValue.push(text);
			retValue.push(slideNavigator_methods.settings.editOriginalValue);
			oThis.trigger('edited', retValue);

			if ($(item).hasClass('selected')) {
				var selText;
				if (slideNavigator_methods.settings.numbering)
					selText = text.length === 0 ? index : (index + ' - ' + text);
				else
					selText = text;

				$(item).parent().parent().prev('.DUIslideNavigator_SingleButton').text(selText);
			}
		},
		add : function(index, value, text) {
			var oThis = $(this);
			var DUIOBJECT = oThis.next();
			var selectbox = $('.DUIslideNavigator_SelectBox',DUIOBJECT);

			if(index < 0) index = 0;

			text = (text == null) ? slideNavigator_methods.settings.editOriginalValue : text;
			var item = slideNavigator_methods.createItem({
				index: index, 
				value: value, 
				text: text
			});
			var insertSibling = selectbox.children('div[data-value]:eq('+ index +')');
			if(arguments.length > 3 && arguments[3] != null && arguments[3].before == true) {
				$(item.html.join('')).insertBefore(insertSibling);
				slideNavigator_methods.addEventHandler(oThis, $(insertSibling).prev()[0], index);
			} else {
				$(item.html.join('')).insertAfter(insertSibling);
				slideNavigator_methods.addEventHandler(oThis, $(insertSibling).next()[0], index+1);
			}
		},
		move : function(index, newIndex) {
			var oThis = $(this);
			var DUIOBJECT = oThis.next();
			var selectbox = $('.DUIslideNavigator_SelectBox',DUIOBJECT);
			var targetItem = selectbox.children('div[data-value]:eq('+ newIndex +')');
			var newItem = selectbox.children('div[data-value]:eq('+ index +')');
			if(newIndex > index)
				newItem.insertAfter(targetItem);
			else 
				newItem.insertBefore(targetItem);
		},
		remove : function(index) {
			var oThis = $(this);
			var DUIOBJECT = oThis.next();
			var selectbox = $('.DUIslideNavigator_SelectBox',DUIOBJECT);
			selectbox.children('div[data-value]:eq('+ index +')').remove();
		}
	};
	var slideNavigator = {};
	slideNavigator.methods = slideNavigator_methods;

	$.fn.DUIslideNavigator = function( method ){
		if( slideNavigator.methods[method] ){
			return slideNavigator.methods[ method ].apply( this, Array.prototype.slice.call ( arguments, 1 ));
		} else if ( typeof method === 'object' || !method ){
			return slideNavigator.methods.init.apply( this, arguments );
		}
	}
})(jQuery);